export default [
	{
		ageGroup: 'Ungdom',
		productName: 'Multihyr',
		price: 955,
		id: -501863714,
		value: '1',
		startDate: '2021-02-27',
		endDate: '2021-03-06',
		displayLength: '8 dagar',
		addrlid: '',
		detlid: '',
		begindate: '2021-02-27',
		length: '8 dagar',
		qty: '1',
		pricecode: '',
		poollid: -501863714,
		priceWithInsurance: 1155,
		keynumber: '',
		fromAge: 0,
		toAge: 0,
		levels: [
			{ id: 1, label: 'Bas' },
			{ id: 2, label: 'Medel' },
			{ id: 3, label: 'Avancerad' }
		],
		image:
			'http://static.r360online.se/klappen/images/72d79b827b81047c16e1ecdead57185d_org.jpg',
		periodOfValidity: '',
		groupName: '',
		startTime: '',
		endTime: '',
		isPackage: true,
		isForSale: false,
		insurance: false,
		comment: ''
	},
	{
		ageGroup: 'Vuxen',
		productName: 'Alpin skida',
		price: 1005,
		id: 1087351705,
		value: '1',
		startDate: '2021-02-27',
		endDate: '2021-03-06',
		displayLength: '8 dagar',
		addrlid: '',
		detlid: '',
		begindate: '2021-02-27',
		length: '8 dagar',
		qty: '1',
		pricecode: '',
		poollid: 1087351705,
		priceWithInsurance: 1155,
		keynumber: '',
		fromAge: 0,
		toAge: 0,
		levels: [{ id: 3, label: 'Avancerad' }],
		image:
			'http://static.r360online.se/klappen/images/72d79b827b81047c16e1ecdead57185d_org.jpg',
		periodOfValidity: '',
		groupName: '',
		startTime: '',
		endTime: '',
		isPackage: false,
		isForSale: false,
		insurance: false,
		comment: ''
	},
	{
		ageGroup: 'Barn',
		productName: 'Ryggskydd',
		price: 325,
		id: 2114332702,
		value: '1',
		startDate: '2021-02-27',
		endDate: '2021-03-06',
		displayLength: '8 dagar',
		addrlid: '',
		detlid: '',
		begindate: '2021-02-27',
		length: '8 dagar',
		qty: '1',
		pricecode: '',
		poollid: 2114332702,
		priceWithInsurance: 375,
		keynumber: '',
		fromAge: 0,
		toAge: 0,
		levels: [
			{ id: 1, label: 'Bas' },
			{ id: 2, label: 'Medel' },
			{ id: 3, label: 'Avancerad' }
		],
		image:
			'http://static.r360online.se/klappen/images/7e0f6f38a5af17f3e3a2185fa3a053f8_org.jpg',
		periodOfValidity: '',
		groupName: '',
		startTime: '',
		endTime: '',
		isPackage: false,
		isForSale: true,
		insurance: false,
		comment: ''
	}
]
